import './landingstyles.css';

import { actions } from 'app/containers/Auth/slice';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Outlet } from 'react-router';
import { useLocation } from 'react-router-dom';

import { Box, Button, Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

import LandingPage from '../LandingPage';
import Content from './components/content';
import SocketManager from './components/SocketManager';

type Props = {};

const useStyles = makeStyles((theme: Theme) => ({
  main: {
    display: 'flex',
    backgroundColor: '#F9FAFB'
  },
  contentDiv: {
    backgroundColor: '#F9FAFB',
    padding: '2rem 1rem 0rem 1.7rem'
  },
  dateInput: {
    paddingTop: 20,
    borderRadius: 10,
    gap: 10,
    display: 'flex'
  },
  noOfUser: {
    width: '100%',
    height: '4.7%',
    borderRadius: "10px",
  },
  content: {
    padding: '1%',
    backgroundColor: '#F9FAFB'
  },
  error: {
    width: '100%',
    textAlign: 'center',
    justifyContent: 'center',
    marginBottom: '10px',
  },
}));

export const MainScren = () => {
  const styles = useStyles()

  return (
    <div className={styles.content} >
      <Button
        variant="contained"
        disableElevation
        disableRipple
        disableTouchRipple
        sx={{ color: '#fff', fontSize: '0.875rem', fontWeight: '500', cursor: 'auto' }}
        className={styles.noOfUser}
      >
        Number of users: 20800
      </Button>
    </div>
  )
}


const DashboardPage = (props: Props) => {
  const styles = useStyles()
  const location = useLocation();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(actions.getCurrentUser())
  }, [])

  const userId = localStorage.getItem('userId');


  return <Box className={styles.main}>
    <Content>
      <SocketManager userId={userId} />
      {/* {!checkAvailability && <Alert className={styles.error} severity="error">
        Someone is using this page, You can not edit or update this page
      </Alert>} */}
      {location.pathname === '/dashboard' ? <LandingPage /> :
        <Outlet />
      }
    </Content>
  </Box >;
};

export default DashboardPage;
